import React, { memo } from 'react';

const DownloadIcon = ({ color = '#335B70' }) => {
    return (
        <svg width={32} height={32} xmlns="http://www.w3.org/2000/svg">
            <defs>
                <path
                    d="M27.294 16.029h-8.47v7.542h-6.427l8.47 8.486H0V0h27.294v16.029z"
                    id="download-icon-a"
                />
            </defs>
            <g fill="none" fillRule="evenodd">
                <g transform="translate(0 -1)">
                    <mask id="download-icon-b" fill="#fff">
                        <use xlinkHref="#download-icon-a" />
                    </mask>
                    <g mask="url(#download-icon-b)" stroke="#3C4248" strokeWidth=".941">
                        <path
                            d="M23.992 29.91H4.785c-.7.08-1.07-.198-1.11-.837-.04-.638-.04-9.471 0-26.5.063-.596.433-.876 1.11-.84.665.036 4.793.02 12.385-.05a1.04 1.04 0 0 1 .43.118c.104.048.205.123.306.225l7.043 7.188c.022 12.75.022 19.37 0 19.86-.023.49-.342.768-.957.835z"
                            fill="#FAFBFC"
                        />
                        <path d="M16.941 1.886v6.116c.163.951.633 1.422 1.41 1.412.776-.01 2.816-.005 6.12.015" />
                    </g>
                </g>
                <path
                    d="M28.235 24.444H32l-7.53 7.53-7.529-7.53h3.765v-7.53h7.53v7.53z"
                    fill="#3C4248"
                />
            </g>
        </svg>
    );
};

export default memo(DownloadIcon);
